import styled from 'styled-components';

// Carousel skeleton wrapper (used in categoryCarousel.tsx and presetCarousel.tsx)
export const CarouselInner = styled.div`
    position: relative;
    max-width: 100%;
    margin: 0 auto;
`;

// Dialog shared components (used in saveToLibraryModal.tsx and moveToCategoryDialog.tsx)
export const DialogContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    min-width: 400px;
`;

export const DialogLoadingState = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    min-width: 400px;
    color: #78909c;
`;

export const DialogFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 8px;
`;

// Hidden file input (used in bottomPanel.tsx)
export const HiddenInput = styled.input`
    display: none;
`;

// Dropdown menu components (used in resultItem.tsx and assetItem.tsx)
export const DropdownMenuItem = styled.button<{ $danger?: boolean }>`
    width: 100%;
    padding: 8px 12px;
    border: none;
    background: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: ${(props) => (props.$danger ? '#e53935' : '#455a64')};
    transition: background 0.15s;

    &:hover {
        background: ${(props) => (props.$danger ? '#fbe9e7' : '#f5f5f5')};
    }

    svg {
        width: 14px;
        height: 14px;
        fill: ${(props) => (props.$danger ? '#e53935' : '#455a64')};
    }
`;

export const DropdownDivider = styled.div`
    height: 1px;
    background: #e0e0e0;
    margin: 4px 0;
`;

export const ActionButton = styled.button`
    padding: 8px;
    border: none;
    background: rgba(255, 255, 255, 0.95);
    cursor: pointer;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: all 0.2s;

    &:hover {
        background: white;
        transform: scale(1.05);
    }

    svg {
        width: 14px;
        height: 14px;
        fill: #455a64;
    }
`;

export const ExpandButton = styled.button`
    position: absolute;
    bottom: 8px;
    right: 8px;
    padding: 8px;
    border: none;
    background: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    &:hover {
        background: rgba(0, 0, 0, 0.8);
        transform: scale(1.05);
    }

    svg {
        width: 14px;
        height: 14px;
        fill: white;
    }
`;
